class CursorButtonHover extends HTMLElement {
    constructor() {
        super();
        const selector = this.dataset.classSelector ?? 'img';
        this.button = this.querySelector('.hover-button');
        this.images = this.querySelectorAll(selector);

        for (const image of this.images) {
            image.addEventListener('mousemove', (e) => {
                this.button.style.left = e.clientX + 'px';
                this.button.style.top = e.clientY + 'px';

                if (this.button.classList.contains('xhidden')) {
                    this.button.classList.remove('xhidden');
                }
            });

            image.addEventListener('mouseleave', () => {
                this.button.classList.add('xhidden');
            });

            image.addEventListener('click', (e) => {
                this.button.classList.add('clicked');
                setTimeout(() => {
                    this.button.classList.remove('clicked');
                }, 200);
            });
        }
    }
}

customElements.define('cursor-button-hover', CursorButtonHover);
